import React from 'react';
import { ReactComponent as Notifica } from "../../../assets/new-icons/notifica.svg";
import { ReactComponent as Close } from "../../../assets/new-icons/close.svg";
import ArrowForwardIos from '@mui/icons-material/ArrowForwardIos';
import EuroIcon from '@mui/icons-material/Euro';
import { useSelector } from 'react-redux';
import { DateTime } from 'luxon';
import TimeAgo from 'timeago-react';
import * as timeago from 'timeago.js';
import it from 'timeago.js/lib/lang/it';
import './_notification.scss'

timeago.register('it', it);

function Notification({ handleNotification }) {
    const section = useSelector((user) => user.settings.section)
    const selectorUser = useSelector((user) => user.user)
    const notificheGas = useSelector((user) => user?.gas?.notifiche)
    const notificheEn = selectorUser.notifiche
    const notifiche = section ? notificheGas : notificheEn
    const allNotifiche = notifiche && [...notifiche[0], ...notifiche[1]]
    
    return (
        <div className="notificationComponent">
            <div className="body">
                {allNotifiche.length > 0 ? allNotifiche.map((r) => (
                    <div className="item" key={r.id}>
                        <div className="icon">
                            <EuroIcon/>
                        </div>
                        <div className="info">
                            <span className="time">
                                <TimeAgo
                                    datetime={r.data_inserimento}
                                    locale='it'
                                />
                            </span>
                            <p className="main">Incasso programmato</p>
                            <p className="detail">
                                Il giorno {DateTime.fromISO(r.data_scadenza).toFormat('DD')} proveremo ad incassare {parseFloat(r.importo).toFixed(2).replace(/\./g, ",")} €, <span className='bold'>{r.causale}</span>, {r.token === undefined ? `dal tuo conto corrente ${r.iban !== undefined ? '****'.concat(r.iban.slice(r.iban.length - 4)) : null }` : `dalla tua carta registrata **** ${r.token.slice(r.token.length - 4)}`}.
                            </p>
                        </div>
                        <div className="arrow">
                            {/* <ArrowForwardIos /> */}
                        </div>
                    </div>
                )) : (
                    <div className="item no-items">
                        <p className='main'>Non ci sono notifiche al momento.</p>
                    </div>
                )}

            </div>
        </div>
    );
}

export default Notification;
